module.exports = __webpack_public_path__ + "assets/img/progress.b90f78a8.png";